// extracted by mini-css-extract-plugin
module.exports = {"Footer":"Footer_Footer__238hM","logo":"Footer_logo__3ACxa","topLogo":"Footer_topLogo__ql0ZB","bottomLogo":"Footer_bottomLogo__2oyg4"};